import WebError from "./WebError";

export default class PermissionDeniedWebError extends WebError {
  constructor(code?: number, message?: string) {
    super(404, code, message);
    this.name = 'Permission Denied';
  }
}
